document.addEventListener('DOMContentLoaded', function(){
  const swipers = document.querySelectorAll('.featured-products__swiper');
  swipers.forEach(swiper => {
    const uniqueId = swiper.getAttribute('data-block-id');
    let newSwiper = new Swiper(`.featured-products__swiper--${uniqueId}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: `.featured-products__pagination--${uniqueId}`,
        clickable: true,
      },
      breakpoints: {
        375: {
          slidesPerView: 1,
          spaceBetween: 15
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  })

  const categories = document.querySelectorAll('.week__day');
  
  let previousSelectedCategorie = categories[0];
  let previousProductList = swipers[0];

  categories.forEach(categorie => {
    categorie.addEventListener('click', function(){
      if (categorie.classList.contains('active')){
        return;
      }
      const blockId = categorie.getAttribute('data-block-id');
      const productsArray = Array.from(swipers);
      const newProductList = productsArray.find(product => product.getAttribute('data-block-id') === blockId);
      
      previousProductList.classList.remove('active');
      previousProductList = newProductList;
      newProductList.classList.add('active');
      previousSelectedCategorie.classList.remove('active');
      previousSelectedCategorie = categorie;
      categorie.classList.add('active');
    })
  })
  // animation additional text
 
});